import axios from "axios";
import { TelegramAuthResponseDto, UserSelectDto } from "definitions/poizon-sso";
import { BITRIX_FORM_LINK } from "src/constants/links";

import {
  BitrixFormParams,
  DeviceInfo,
  PageInfo,
  UrlParams,
} from "./sendBitrixForm.types";

export function getUrlParams(): UrlParams {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
    gclid: params.get("gclid"),
  };
}

export function getPageInfo(): PageInfo {
  return {
    url: window.location.href,
    ref: document.referrer,
    title: document.title || "Untitled",
  };
}

export function getDeviceInfo(): DeviceInfo {
  return {
    isMobile: /Mobi|Android/i.test(navigator.userAgent),
  };
}

export function prepareBitrixData(): BitrixFormParams {
  const urlParams = getUrlParams();
  const deviceInfo = getDeviceInfo();
  const pageInfo = getPageInfo();
  const timestamp = Math.floor(Date.now() / 1000);

  return {
    url: pageInfo.url,
    ref: pageInfo.ref,
    device: {
      isMobile: deviceInfo.isMobile,
    },
    tags: {
      ts: timestamp,
      list: {
        utm_source: urlParams.utm_source,
        utm_medium: urlParams.utm_medium,
        utm_campaign: urlParams.utm_campaign,
        utm_term: urlParams.utm_term,
        utm_content: urlParams.utm_content,
      },
      gclid: urlParams.gclid,
    },
    client: {},
    pages: {
      list: [[pageInfo.url, timestamp, pageInfo.title]],
    },
    gid: null,
    previous: { list: [] },
  };
}

export async function sendBitrixForm(
  user: UserSelectDto,
  telegramInfo: TelegramAuthResponseDto | null,
): Promise<void> {
  const traceParams = prepareBitrixData();

  const form = new FormData();
  form.append("properties", "{}");
  form.append("consents", '{"AGREEMENT_2":"Y"}');
  form.append("recaptcha", "undefined");
  form.append("timeZoneOffset", "-300");

  const telegramFormatted = telegramInfo
    ? `${telegramInfo.username}@telegram.chatapp.online`
    : undefined;

  form.append(
    "values",
    JSON.stringify({
      CONTACT_NAME: [user.firstName || user.name],
      CONTACT_LAST_NAME: [user.lastName],
      CONTACT_PHONE: [user.phone],
      CONTACT_EMAIL: [user.email, telegramFormatted],
    }),
  );

  form.append("id", "22");
  form.append("sec", "om22oa");
  form.append("lang", "ru");
  form.append("trace", JSON.stringify(traceParams));
  form.append("entities", "[]");
  form.append("security_sign", "undefined");

  await axios.post(BITRIX_FORM_LINK, form, {
    params: {
      action: "crm.site.form.fill",
      mode: "class",
    },
  });
}
